<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="تعریف ویژگی‌های شغل"
        description="این بخش برای تعریف ویژگی‌های کلیدی شغل شامل مسئولیت‌ها، اهداف و شرایط کار است."
    />

    <div class="row">
      <div class="col-md-6">
        <JobDescriptionGenerallySection/>
      </div>
      <div class="col-md-6">
        <WorkingConditionsSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <JobPurposeSection/>
      </div>
      <div class="col-md-6">
        <JobDefinitionSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ResponsibilitiesSection/>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
      <button type="button" class="btn btn-primary btn-submit-1 custom-p-2" @click="next">
        مرحله بعد
      </button>
    </div>
  </div>
</template>

<script>
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import JobDescriptionGenerallySection from "@/components/JobDescription/StepOne/JobDescriptionGenerallySection.vue";
import JobDefinitionSection from "@/components/JobDescription/StepOne/JobDefinitionSection.vue";
import JobPurposeSection from "@/components/JobDescription/StepOne/JobPurposeSection.vue";
import ResponsibilitiesSection from "@/components/JobDescription/StepOne/ResponsibilitiesSection.vue";
import WorkingConditionsSection from "@/components/JobDescription/StepOne/WorkingConditionsSection.vue";

export default {
  components: {
    WorkingConditionsSection,
    ResponsibilitiesSection,
    JobPurposeSection,
    JobDefinitionSection,
    JobDescriptionGenerallySection,
    JobDescriptionHeader
  },
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/job-descriptions/get-first',
      afterMutation: 'jobDescription/setJobDescription'
    });
  },
  methods: {
    next() {
      this.$store.dispatch('crudActions/create', {
        resourceData: this.$store.state.jobDescription.jobDescription,
        endpoint: '/job-descriptions',
      })

      this.$emit("next");
    }
  },
};
</script>
